import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const OrderService = {
    list: async (filters) => axios.post(API_URL + "/orders/list", {filters}).then(({data}) => data).catch(err => { throw err }),

    get: async (id) => axios.get(API_URL + "/orders/" + id).then(({data}) => data).catch(err => { throw err }),

    create: async (model) => axios.post(API_URL + "/orders", model).then(({data}) => data).catch(err => { throw err }),

    edit: async (model, id) => axios.post(API_URL + "/orders/" + id, model).then(({data}) => data).catch(err => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/orders/" + id).then(({data}) => data).catch(err => { throw err }),

    formOptions: async (hardware_attendance_id, id) => axios.get(API_URL + "/orders/form-options/" + hardware_attendance_id + (parseInt(id) ? `/${id}` : "")).then(({data}) => data).catch(err => { throw err }),
};

export default OrderService;